<div class="form-group">
  <label class="custom-form-label" for="reportTypeButton">{{ title ? title : ('title.report-type' | translate) }}</label>
  <button type="button" id="reportTypeButton" class="btn btn-outline-secondary w-100" (click)="openModal()">
    {{ translatekey+"."+selected | translate}}
  </button>
</div>